export const view = {
    methods: {
        pay: function () {
            var _self = this;
            var profileContainer = document.querySelector('section[name=Profile]');
            var branchContainer = document.querySelector('section[name=Branch]');
            var gratuityContainer = document.querySelector('section[name=Gratuity]');
            var orderDateTimeContainer = document.querySelector('section[name=order-schedule]');

            var deliveryDateTime = null;

            if (orderDateTimeContainer.querySelector('input[name=schedule-order]')?.checked) {
                var deliveryDate = _self.selectedDate;
                var deliveryTime = orderDateTimeContainer.querySelector('select[name=order-scheduled-time-picker] option[selected]').value;
                deliveryDateTime = deliveryDate + ' ' + deliveryTime;
            }

            var parameters = {
                /* Cart */
                Guid: localStorage.cartGuid,

                /* Delivery Option */
                TableNo: _self.$tableNo,
                Tab: _self.$isTab,
                Pickup: profileContainer.querySelector('input[name=Pickup]')?.checked,
                Delivery: profileContainer.querySelector('input[name=Delivery]')?.checked,
                DeliveryFee: profileContainer.querySelector('input[name=DeliveryFee]')?.value,

                /* Profile */
                MembershipUserID: localStorage.userMembershipID,
                Address: profileContainer.querySelector('textarea[name=Address]')?.value,
                Province: profileContainer.querySelector('input[name=Province]')?.value,
                Country: profileContainer.querySelector('input[name=Country]')?.value,
                AreaCode: profileContainer.querySelector('input[name=AreaCode]')?.value,

                /* Franchise */
                FranchiseID: localStorage.franchiseID,
                FranchiseName: localStorage.franchiseName,

                /* Branch */
                BranchID: branchContainer.getAttribute('data-id'),

                /* Gratuity */
                Gratuity: gratuityContainer.querySelector('input').value,

                /*Order date and time*/
                DeliveryDateTime: deliveryDateTime
            }

            if (validate(this, parameters)) {
                _self.$ooApi.orders.checkout.submit.v1(parameters).then(function (response) {
                    if (response.success) {
                        _self.paymentReference = response.data.paymentReference;
                        if (response.data.redirect) {
                            var parameters = {
                                FranchiseID: localStorage.franchiseID,
                                MembershipUserId: localStorage.userMembershipID,
                                PaymentReference: response.data.paymentReference,
                                Token: null
                            }
                            _self.$ooApi.orders.payment.pay.v1(parameters).then(function (response) {
                                if (!response.success)
                                    throw new Error(response.message);

                                var result = response.data;
                                _self.paymentProvider = result.paymentProvider;
                                _self.paymentReference = result.paymentReference;
                                _self.branchID = result.branchID;
                                _self.paymentKey = result.paymentKey;

                                if (!result.paymentProvider)
                                    window.location.href = result.redirectTo;
                                else
                                    _self.redirect(result.redirectTo, { PaymentProvider: result.paymentProvider, PaymentReference: result.paymentReference, BranchID: result.branchID, PaymentKey: result.paymentKey });

                            });
                        } else {
                            _self.showCreditCards()
                        }
                    } else {
                        throw new Error(response.message);
                    }

                })
            }
        },
        showProfile: function (e) {
            e.stopPropagation();

            document.querySelector('section[name=Profile] div[name=ProfileContainer]').style.display = 'block';
            document.querySelector('section[name=Profile] div[name=ProfileUpdateContainer]').style.display = 'block';
        },
        showBranches: function () {
            var _self = this;

            this.$ooApi.orders.branches.v1({ franchiseID: localStorage.franchiseID })
                .then(function (result) {
                    _self.$refs.selectBranchModal.openModal();
                    _self.$refs.selectBranchModal.populate(result.data);
                }).then(function () {
                    document.querySelectorAll('div[name=BranchContainer] .branch-select button').forEach(item => {
                        item.addEventListener('click', _self.selectBranch);
                    });
                })
        },
        showCreditCards: function () {
            var _self = this;
            var parameters = {
                Guid: localStorage.cartGuid,
                FranchiseID: localStorage.franchiseID,
                MembershipUserID: localStorage.userMembershipID,
            };
            this.$ooApi.orders.checkout.cards.v1(parameters)
                .then(function (result) {
                    _self.$refs.creditCardsModal.openModal();
                    _self.$refs.creditCardsModal.populate(result.data);
                });
        },
        deliver: function (e) {
            var _self = this;
            var button = e.target.closest('.deliver-option');
            var inputContainers = document.querySelectorAll('button.deliver-option');
            var profileContainer = document.querySelector('section[name=Profile]');

            if (button.getAttribute('name') === 'DeliveryOption-Pickup') {
                button.querySelector('div[name=ProfileContainer]').style.display = 'block';
                document.querySelector('section[name=Profile] div[name=ProfileUpdateContainer]').style.display = 'none';
            } else if (button.getAttribute('name') === 'DeliveryOption-Delivery') {
                button.querySelector('div[name=ProfileContainer]').style.display = 'block';
                document.querySelector('section[name=Profile] div[name=ProfileUpdateContainer]').style.display = 'block';
            }
            inputContainers.forEach(item => { item.classList.remove('selected') });
            profileContainer.querySelectorAll('input').forEach(item => { item.checked = false; });

            button.classList.add('selected');
            button.querySelector('input').checked = true;

            document.querySelector('div.checkout-pay').style.display = 'block';
            document.querySelector('div.checkout-pay').addEventListener('click', _self.pay);

            updateCartTotals(_self);
        },
        scheduleOrder: function (e) {
            var button = e.target.closest('button');
            var inputContainers = document.querySelectorAll('button[name=order-time]');

            inputContainers.forEach(item => {
                item.classList.remove('selected');
                item.querySelector('input').checked = false;
            });

            button.classList.add('selected');
            button.querySelector('input').checked = true;

            if (button.querySelector('input').getAttribute('name') == 'schedule-order') {
                document.querySelector('section[name=order-schedule] div[name=order-scheduled-datetime-picker-container]').style.display = 'block';
                updateAvailableOrderTimes(this);
            } else {
                document.querySelector('section[name=order-schedule] div[name=order-scheduled-datetime-picker-container]').style.display = 'none';
            }
        },
        cartTotalChange: function (e) {
            var _self = this;
            var inputSection = e.target.parentNode;
            inputSection.querySelector('button').classList.remove('activated');
            updateCartTotals(_self);
        },
        changeScheduledDate: function () {
            updateAvailableOrderTimes(this);
        },
        selectGratuityPercentage: function (e) {
            var _self = this;
            var button = e.target;
            var buttonsSection = button.parentNode;
            var gratuityField = document.querySelector('section[name=Gratuity] input[type=number]');
            var cartTotal = document.querySelector('section[name=Invoice] input[name=cartTotal]').value;
            var percentageValue = button.value;

            buttonsSection.querySelectorAll('button').forEach(item => { item.classList.remove('activated') });
            gratuityField.value = ((cartTotal * percentageValue) / 100).toFixed(2);
            e.target.classList.add('activated');
            updateCartTotals(_self);
        },
        updateLocation: function () {
            var _self = this;
            var parameters = this.getFormModel('.profileUpdateContainer');
            parameters.FranchiseID = localStorage.franchiseID;

            var payButton = document.querySelector('div.checkout-pay');
            if (validateAddress(_self, parameters)) {
                this.$ooApi.orders.location.validate.v1(parameters).then(function (response) {
                    if (response.success) {
                        var errorText = document.querySelector('div[name=ProfileUpdateContainer] span.error-text');

                        if (response.data.valid == true) {
                            _self.getDistance(_self);
                            errorText.style.display = 'none';
                            payButton.style.display = 'block'
                            document.querySelector('div.checkout-pay').addEventListener('click', _self.pay);
                        } else {
                            errorText.style.display = 'block';
                            payButton.style.display = 'none'
                        }
                    } else {
                        console.log(response.message);
                    }
                })
                // check .catch
            } else
                payButton.style.display = 'none'
        },
        getDistance: function (_self) {
            if (_self == null)
                _self = this;

            var parameters = this.getFormModel('.profileUpdateContainer');

            if (parameters) {
                parameters.Guid = localStorage.cartGuid;
                parameters.FranchiseID = localStorage.franchiseID;

                var distanceElem = document.querySelector('section[name=Profile] div.distance');
                var maxDeliveryDistanceElem = document.querySelector('section[name=Profile] div.maxDeliveryDistance');
                _self.$ooApi.orders.location.distance.v1(parameters).then(function (response) {
                    if (response.success) {
                        if (response.data.valid) {
                            var distance = 'You are ' + response.data.distance + ' from the branch.';
                            distanceElem.innerHTML = distance;

                            var maxDeliveryDistance = 'They deliver within a ' + response.data.maxDeliveryDistance + ' radius.';
                            maxDeliveryDistanceElem.innerHTML = maxDeliveryDistance;
                        } else
                            distanceElem.innerHTML = '';
                    } else {
                        console.log(response.message);
                        distanceElem.innerHTML = '';
                    }
                })
                // check .catch
            }
        },
        initializeDatePicker: function () {
            var _self = this;
            this.$ooApi.orders.checkout.dates.range.v1().then(function (response) {
                if (response.success) {
                    var startDate = new Date(response.data.startDate);
                    var endDate = new Date(response.data.endDate);
                    var currentDate = new Date();

                    _self.minDate = startDate;
                    _self.maxDate = endDate;
                    _self.selectedDate = currentDate;
                } else {
                    console.log(response.message);
                }
            })
            // check .catch
        },
        selectBranch: function (e) {
            e.preventDefault();
            var _self = this;
            var container = e.target.closest('div[name=BranchContainer]');

            var branchID = container.getAttribute('data-id');
            var branchName = container.querySelector('h3').textContent;
            var map = container.querySelector('iframe');
            var contact = container.querySelector('div.branch-contact label.contact').textContent;
            var email = container.querySelector('div.branch-email label.email').textContent;

            var checkoutContainer = document.querySelector('div[name=CheckoutContainer] section[name=Branch]')
            checkoutContainer.getAttribute('data-id', branchID);
            checkoutContainer.querySelector('h5').textContent = branchName
            checkoutContainer.querySelector('iframe').src = map.src;
            checkoutContainer.querySelector('div.branch-contact label.contact').textContent = contact;
            checkoutContainer.querySelector('div.branch-email label.email').textContent = email;

            _self.$refs.selectBranchModal.closeModal();
        },
        selectCreditCard: function () {
            var _self = this;
            var token = document.querySelector('.credit-card-container ul li.selected').getAttribute('data-token');
            _self.$parent.$refs.creditCardsModal.showLoader();
            var parameters = {
                FranchiseID: localStorage.franchiseID,
                MembershipUserId: localStorage.userMembershipID,
                PaymentReference: _self.$parent.paymentReference,
                Token: token
            }
            _self.$ooApi.orders.payment.pay.v1(parameters).then(function (response) {
                if (!response.success)
                    throw new Error(response.message);

                var result = response.data;
                _self.$parent.$refs.LoaderForm.showForm(false);

                if (!result.paymentProvider)
                    window.location.href = result.redirectTo;
                else
                    _self.redirect(result.redirectTo, { PaymentProvider: result.paymentProvider, PaymentReference: result.paymentReference, BranchID: result.branchID, PaymentKey: result.paymentKey });

            });
        }
    }
}

function validate(_self, model) {
    if (!model.TableNo && !model.Tab && !model.Delivery && !model.Pickup) {
        _self.showToaster('Oops', 'No delivery option has been selected.', 'danger');
        return false;
    }
    
    if (model.Delivery)
        return validateAddress(_self, model);

    var orderDateTimeContainer = document.querySelector('section[name=order-schedule]');
    var selectedDate = _self.selectedDate;
    if ((orderDateTimeContainer.querySelector('input[name=schedule-order]').getAttribute('checked')) == false && selectedDate == '') {
        _self.showToaster('Oops', 'No order date and time has been selected.', 'danger');
        return false;
    }

    return true;
}

function validateAddress(_self, model) {
    if (_self.isStringNullOrEmpty(model.Address)) {
        _self.showToaster('Oops', 'No delivery address specified.', 'danger');
        return false;
    }
    if (_self.isStringNullOrEmpty(model.Province)) {
        _self.showToaster('Oops', 'No delivery province specified.', 'danger');
        return false;
    }
    if (_self.isStringNullOrEmpty(model.Country)) {
        _self.showToaster('Oops', 'No delivery country specified.', 'danger');
        return false;
    }
    if (_self.isStringNullOrEmpty(model.AreaCode)) {
        _self.showToaster('Oops', 'No delivery zip / area code specified.', 'danger');
        return false;
    }

    return true;
}

function updateCartTotals(_self) {
    var profileContainer = document.querySelector('section[name=Profile]');
    var deliveryCheckbox = profileContainer.querySelectorAll('input[name=Delivery]')[0];
    var delivery = false
    if (deliveryCheckbox != null || deliveryCheckbox != undefined)
        delivery = deliveryCheckbox.checked;

    var deliveryFee = 0;
    if (delivery)
        deliveryFee = profileContainer.querySelector('input[name=DeliveryFee]').value;

    var gratuity = parseFloat(document.querySelector('section[name=Gratuity] input[type=number]').value);
    if (!gratuity)
        gratuity = 0;

    var parameters = {
        FranchiseID: localStorage.franchiseID,
        Guid: localStorage.cartGuid,
        Gratuity: gratuity,
        DeliveryFee: deliveryFee
    };
    _self.$ooApi.orders.cart.totals.v1(parameters).then(function (response) {
        _self.$refs.cartTotals.populate(response.data);
    })
}

function updateAvailableOrderTimes(_self) {
    // var branchContainer = document.querySelector('section[name=Branch]');
    // var branchID = branchContainer.getAttribute('data-id');
    var scheduledDay = _self.selectedDate;

    var parameters = {
        FranchiseID: localStorage.franchiseID,
        BranchID: localStorage.branchID,
        ScheduledDay: scheduledDay
    };
    _self.$ooApi.orders.checkout.delivery_times.v1(parameters).then(function (response) {
        if (response.success) {
            var html = '';
            response.data.availableScheduledDeliveryTimes.forEach((item, i) => {
                if (i == 0) {
                    html += '<option value="' + item + '" selected >' + item + '</option>'
                }
                html += '<option value="' + item + '">' + item + '</option>';
            });

            document.querySelector('select[name=order-scheduled-time-picker]').innerHTML = html;
        } else {
            console.log(response.message);
        }
    })
    // check .catch
}